import { render, staticRenderFns } from "./evaluacion-identificacion.vue?vue&type=template&id=2c67236d&scoped=true&"
import script from "./evaluacion-identificacion.vue?vue&type=script&lang=js&"
export * from "./evaluacion-identificacion.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-identificacion.vue?vue&type=style&index=0&id=2c67236d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67236d",
  null
  
)

export default component.exports